import React from "react";
import PropTypes from "prop-types";
// mui
import { Grid2 } from "@mui/material";
//styling
import styles from "./Storage.module.scss";
import Skeleton from "@mui/material/Skeleton";

export default function Storage(props) {
  const { unit, use, type, icon, status, staging, userDetails } = props;
  const Icon = icon;

  return (
    <>
      {status ? (
        <Skeleton
          variant="rounded"
          width="100%"
          height={50}
          sx={{
            backgroundColor:
              userDetails === "dark" ? "#f0f0f0" : "rgba(0,0,0,0.11)",
          }}
        />
      ) : (
        <Grid2
          className={`${
            !staging ? styles.StorageContainer : styles.devBackground
          }`}
        >
          <Grid2 className={styles.FlexBox}>
            <Grid2 className={styles.unit}>{unit}</Grid2>
            <Grid2 className={styles.use}>{use}</Grid2>
          </Grid2>
          <Grid2 className={styles.type}>{type}</Grid2>
          <Grid2 className={styles.IconWrapper}>
            <Icon className={styles.icon} />
          </Grid2>
        </Grid2>
      )}
    </>
  );
}

Storage.propTypes = {
  icon: PropTypes.elementType.isRequired,
  unit: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  use: PropTypes.string,
  type: PropTypes.string,
};
